import { MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "@/i18n/LangContext";

const STOP_MEDIA = [
  { n: "01", src: "/images/gallery-5.jpg" },
  { n: "02", src: "/images/gallery-6.jpg" },
  { n: "03", src: "/images/gallery-7.jpg" },
  { n: "04", src: "/images/gallery-8.jpg" },
  { n: "05", src: "/images/gallery-9.jpg" },
];

export default function Yatra() {
  const { t } = useLang();
  const stops = t("yatra.stops");
  return (
    <section id="yatra" data-testid="yatra-section" className="px-5 py-24 sm:px-8 lg:py-36" style={{ backgroundColor: "var(--bg-surface)" }}>
      <div className="mx-auto max-w-6xl">
        <Reveal className="mb-16 max-w-2xl">
          <Eyebrow>{t("yatra.eyebrow")}</Eyebrow>
          <h2 className="font-display mt-6 text-3xl font-light tracking-tight sm:text-4xl lg:text-5xl">
            {t("yatra.h1")}
            <br />
            <span className="italic" style={{ color: "var(--accent-gold)" }}>{t("yatra.h2")}</span>
          </h2>
          <p className="mt-6 text-base leading-relaxed" style={{ color: "var(--text-secondary)" }}>
            {t("yatra.intro")}
          </p>
        </Reveal>

        <div className="relative">
          <div
            className="absolute left-[19px] top-2 bottom-2 w-px sm:left-[23px]"
            style={{ background: "linear-gradient(to bottom, transparent, var(--border-hover) 8%, var(--border-hover) 92%, transparent)" }}
          />
          <div className="space-y-14 sm:space-y-20">
            {STOP_MEDIA.map((m, i) => (
              <Reveal key={m.n} delay={0.05}>
                <article
                  data-testid={`yatra-stop-${i + 1}`}
                  className={`relative grid gap-6 pl-14 sm:pl-16 md:grid-cols-[0.85fr_1.15fr] md:gap-12 ${i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""}`}
                >
                  <span
                    className="absolute left-0 top-1 flex h-10 w-10 items-center justify-center rounded-full border sm:h-12 sm:w-12"
                    style={{ borderColor: "var(--border-hover)", backgroundColor: "var(--bg-canvas)", color: "var(--accent-gold)" }}
                  >
                    <MapPin size={16} strokeWidth={1.75} />
                  </span>

                  <div className="overflow-hidden rounded-2xl border" style={{ borderColor: "var(--border-delicate)" }}>
                    <img
                      src={m.src}
                      alt={`Maa Prem Mahima — ${stops[i].title}`}
                      loading="lazy"
                      className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-[1.04]"
                    />
                  </div>

                  <div className="self-center">
                    <p className="font-mono-alt text-xs tracking-[0.3em]" style={{ color: "var(--accent-gold)" }}>
                      {t("yatra.stopLabel")} {m.n}
                    </p>
                    <h3 className="font-display mt-3 text-2xl font-normal leading-snug sm:text-3xl">{stops[i].title}</h3>
                    <p className="mt-4 max-w-lg text-sm leading-relaxed sm:text-base" style={{ color: "var(--text-secondary)" }}>
                      {stops[i].body}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal className="mt-16">
          <p className="font-display mx-auto max-w-xl text-center text-xl italic sm:text-2xl" style={{ color: "var(--text-secondary)" }}>
            {t("yatra.close1")}
            <span style={{ color: 'var(--accent-gold)' }}>{t("yatra.close2")}</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
